import { Component, Input, forwardRef, Inject }   from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgForm }             from '@angular/forms';
import { TranslateService }   from '@ngx-translate/core';
import { UIRouter }           from '@uirouter/core';

import { CarfaxService }   from './carfax.service';
import { CodeTypeModel }   from '../core/models/code-type';
import { CompanyService }  from '../companies/company.service';
import { ConfirmService }  from '../messages/confirm/confirm.service';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector   : 'carfax-settings',
  template: require('./carfax.settings.component.html')
})
export class CarfaxSettingsComponent {
  @BlockUI('carfaxBlock') block : NgBlockUI;

  @Input() company: any;
  @Input() states : Array<CodeTypeModel>;

  title : string = this.carfaxService.title;

  constructor (
    @Inject(forwardRef(() => CarfaxService)) private carfaxService   : CarfaxService,
    @Inject(forwardRef(() => CompanyService))
    public  companyService  : CompanyService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService  : ConfirmService,
    @Inject(forwardRef(() => MessagesService)) private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  activate () : void {
    this.confirmService.generic(this.carfaxService.getActivateMessage())
    .then(() => this.carfaxService.activate())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error=> this.messagesService.error(error));
  }

  authorize () : void {
    this.block.start();

    this.carfaxService.saveSettings(this.company)
    .then(() => this.carfaxService.authorize())
    .then(( message : string ) => {
      this.messagesService.show(message, 'success');

      this.router.stateService.reload();
    })
    .catch(error=> this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  deactivate () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', {
      name: this.title
    }))
    .then(() => this.carfaxService.deactivate())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error=> this.messagesService.error(error));
  }

  save ( form : NgForm ) : void {
    this.block.start(this.translateService.instant('GENERAL_SPACE.MESSAGE.SAVING'));

    this.carfaxService.saveSettings(this.company)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      this.router.stateService.reload();
    })
    .catch(error=> this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
